module.exports = __webpack_public_path__ + "media/images/menu/m10-ff9c3337b9b13974552cea9b9325af22.JPG";